import { mergeStyles, Stack, useTheme } from '@fluentui/react';
import React from 'react';
import { BaseComponentProps, Input } from '../types';

export const CircularButtonGroup = (props: BaseComponentProps): JSX.Element => {
  const { inputs, onSubmit } = props;
  const theme = useTheme();

  const circularButtonStyle = mergeStyles({
    background: 'white',
    cursor: 'pointer',
    height: '91px',
    width: '91px',
    border: 'none',
    borderRadius: '50%',
    boxShadow: theme.effects.elevation8,
    color: theme.palette.white,
    fontSize: '20px',
    '> p': {
      lineHeight: '0rem',
    },
  });

  const handleSubmit = (inputs: Input) => {
    onSubmit && onSubmit([inputs]);
  };

  return (
    <Stack horizontal horizontalAlign="space-evenly" style={{ width: '80%' }}>
      {inputs.map((input, idx) => (
        <button
          key={idx}
          className={circularButtonStyle}
          onClick={() => handleSubmit(input)}
        >
          <p style={{ fontSize: '2rem' }}>{input.emoji}</p>
          <p>{input.name}</p>
        </button>
      ))}
    </Stack>
  );
};
